var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "downloadFileModal",
      "centered": true,
      "title": "Download Claim",
      "hide-footer": true,
      "size": "lg",
      "hide-header-close": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.getDownloadFiles
    }
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table w-100"
  }, [_c('thead', {}, [_c('tr', [_c('th', {
    staticStyle: {
      "border-top": "0"
    }
  }, [_vm._v("File name")]), _c('th', {
    staticStyle: {
      "border-top": "0"
    }
  }, [_vm._v("Download")])])]), _c('tbody', _vm._l(_vm.files, function (file, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "file-name-download"
    }, [_vm._v(_vm._s(file.filename))]), _c('td', {}, [_c('div', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "action-download",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": ""
      },
      on: {
        "click": function click($event) {
          return _vm.downloadFile(file.url);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-download"
    })])])]);
  }), 0)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }